import React from "react";
import Box from "@mui/material/Box";
import TextField from "@mui/material/TextField";
import InputAdornment from "@mui/material/InputAdornment";
import Button from "@mui/material/Button";
import Tooltip from "@mui/material/Tooltip";
import IconButton from "@mui/material/IconButton";
import {
  Search as SearchIcon,
  ViewList as ViewListIcon,
  AccountTree as AccountTreeIcon,
  Description as DescriptionIcon,
  Close as CloseIcon,
} from "@mui/icons-material";

export function PatrolSearchBar({
  searchQuery = "",
  onSearchChange,
  onMenuClick,
  onFilterClick,
  onViewClick,
  activeButton = "list", // 'menu', 'filter', or 'view'
}) {
  const isMenuActive = activeButton === "list";
  const isFilterActive = activeButton === "path";
  const isViewActive = activeButton === "filename";

  return (
    <Box
      sx={{
        display: "flex",
        alignItems: "center",
        gap: 1,
        px: 2,
        py: 1.5,
        borderBottom: "1px solid",
        borderColor: "#E5E7EB",
        bgcolor: "#F9FAFB",
      }}
    >
      {/* Search Input */}
      <TextField
        placeholder="Search patrols..."
        value={searchQuery}
        onChange={(e) => onSearchChange?.(e.target.value)}
        size="small"
        fullWidth
        InputProps={{
          startAdornment: (
            <InputAdornment position="start">
              <SearchIcon sx={{ color: "#9CA3AF", fontSize: 20 }} />
            </InputAdornment>
          ),
          endAdornment: searchQuery ? (
            <InputAdornment position="end">
              <Tooltip title="Clear search" placement="top" arrow>
                <IconButton
                  size="small"
                  aria-label="Clear search input"
                  onClick={() => onSearchChange?.("")}
                  edge="end"
                  sx={{
                    color: "#9CA3AF",
                    "&:hover": {
                      color: "#4A5565",
                      bgcolor: "transparent",
                    },
                  }}
                >
                  <CloseIcon sx={{ fontSize: 18 }} />
                </IconButton>
              </Tooltip>
            </InputAdornment>
          ) : null,
        }}
        sx={{
          "& .MuiOutlinedInput-root": {
            bgcolor: "white",
            fontFamily: "Roboto, sans-serif",
            fontSize: "14px",
            borderRadius: "8px",
            "& fieldset": {
              borderColor: "#E5E7EB",
            },
            "&:hover fieldset": {
              borderColor: "#D1D5DB",
            },
            "&.Mui-focused fieldset": {
              borderColor: "#2932E5",
            },
          },
          borderRadius: 2,
        }}
      />

      {/* First Button - Menu/List */}
      <Tooltip
        componentsProps={{
          tooltip: {
            sx: {
              fontWeight: 700,
              borderRadius: "10px",
            },
          },
        }}
        title="List View"
        placement="bottom"
        arrow
      >
        <Button
          onClick={onMenuClick}
          variant="outlined"
          sx={{
            minWidth: "40px",
            width: "40px",
            height: "40px",
            p: 0,
            borderRadius: "8px",
            bgcolor: isMenuActive ? "rgba(255, 133, 85, 0.15)" : "white",
            borderColor: isMenuActive ? "#FF8555" : "#E5E7EB",
            borderWidth: "1px",
            borderStyle: "solid",
            "&:hover": {
              bgcolor: isMenuActive ? "rgba(255, 133, 85, 0.25)" : "#F9FAFB",
              borderColor: isMenuActive ? "#FF8555" : "#D1D5DB",
            },
          }}
        >
          <ViewListIcon
            sx={{
              color: isMenuActive ? "#2932E5" : "#4A5565",
              fontSize: 20,
            }}
          />
        </Button>
      </Tooltip>

      {/* Second Button - Network/Hierarchy */}
      {/* <Tooltip
        componentsProps={{
          tooltip: {
            sx: {
              fontWeight: 700,
              borderRadius: "10px",
            },
          },
        }}
        title="Group by Drawing Path"
        placement="bottom"
        arrow
      >
        <Button
          onClick={onFilterClick}
          variant="outlined"
          sx={{
            minWidth: "40px",
            width: "40px",
            height: "40px",
            p: 0,
            borderRadius: "8px",
            bgcolor: isFilterActive ? "rgba(255, 133, 85, 0.15)" : "white",
            borderColor: isFilterActive ? "#FF8555" : "#E5E7EB",
            borderWidth: "1px",
            borderStyle: "solid",
            "&:hover": {
              bgcolor: isFilterActive ? "rgba(255, 133, 85, 0.25)" : "#F9FAFB",
              borderColor: isFilterActive ? "#FF8555" : "#D1D5DB",
            },
          }}
        >
          <AccountTreeIcon
            sx={{
              color: isFilterActive ? "#2932E5" : "#4A5565",
              fontSize: 20,
            }}
          />
        </Button>
      </Tooltip> */}

      {/* Third Button - Document/File */}
      {/* <Tooltip
        componentsProps={{
          tooltip: {
            sx: {
              fontWeight: 700,
              borderRadius: "10px",
            },
          },
        }}
        title="Group by Drawing Name"
        placement="bottom"
        arrow
      >
        <Button
          onClick={onViewClick}
          variant="outlined"
          sx={{
            minWidth: "40px",
            width: "40px",
            height: "40px",
            p: 0,
            borderRadius: "8px",
            bgcolor: isViewActive ? "rgba(255, 133, 85, 0.15)" : "white",
            borderColor: isViewActive ? "#FF8555" : "#E5E7EB",
            borderWidth: "1px",
            borderStyle: "solid",
            "&:hover": {
              bgcolor: isViewActive ? "rgba(255, 133, 85, 0.25)" : "#F9FAFB",
              borderColor: isViewActive ? "#FF8555" : "#D1D5DB",
            },
          }}
        >
          <DescriptionIcon
            sx={{
              color: isViewActive ? "#2932E5" : "#4A5565",
              fontSize: 20,
            }}
          />
        </Button>
      </Tooltip> */}
    </Box>
  );
}
